<script setup>
import { safeLog } from "@utils/log";
import config from "@/config";
import { hideTabBar } from "@utils/utils";
import { autoLogin, initInviteInfo, initOnlyId, onLaunchFinished } from "@utils/user";
import { onLaunch, onShow, onError } from "@dcloudio/uni-app";
import { initClientByQuery, initReportOnline, isWxH5 } from "@utils/business";
import { getUploadSignature } from "@utils/upload";
import realtimeLog from "@utils/realtimeLog";
import { storage } from "@utils/storage";
import { forceRefreshApp, initJsSdkConfig } from "@utils/officialAccount";
import { $emit } from "@utils/events";

document.addEventListener("visibilitychange", () => {
    if (document.hidden) {

    } else {
        $emit('onPageShow')
    }
});

onLaunch(async (e) => {
    // 佛祖保佑
    safeLog();
    console.log(config, '--------当前配置')

    initClientByQuery(e);

    hideTabBar();
    // 初始化唯一id
    initOnlyId();

    if (isWxH5()) {
        forceRefreshApp();
        await initJsSdkConfig()
    }

    storage.remove('location')
    // storage.remove('routeCache')
    // if (e.path !== "pages/common/h5-transit/index") {
    //     const isAppLunchAutoLogin = storage.get('isAppLunchAutoLogin');
    //     storage.remove('isAppLunchAutoLogin')
    //     if (isAppLunchAutoLogin !== -1) {
    //         // 用户自动登录
    //         autoLogin();
    //     }
    // }

    onLaunchFinished()

    // 上报用户在线
    initReportOnline()
    // 更新上传图片token
    getUploadSignature();
})

/**
 * 收集全局错误日志
 */
onError((e) => {
    try {
        console.error(e)
        realtimeLog.error(e);
    } catch (e) {

    }
});

onShow((options) => {
    console.log('APP - onShow:', options)
    // 记录邀请赚钱信息
    initInviteInfo(options);
})

</script>

<style lang="scss">
@import "@/common/scss/index.scss";

page {
    width: 750rpx;
    margin: 0 auto;
    min-height: 101vh;
    font-family: PingFang SC, PingFang SC;
    background: #0E0F11;
}

html {
    --safe-bottom: constant(safe-area-inset-bottom);
    --safe-bottom: env(safe-area-inset-bottom);
}

.safe-bottom {
    height: var(--safe-bottom);
}
</style>
